import React from "react";
import Navbar from "./Navbar";
import SideBar from "./SideBar";
import { useState } from "react";
const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const attendanceData = [
    {
      empName: "John Doe",
      inTime: "09:00 AM",
      outTime: "05:00 PM",
      status: "Present",
    },
    {
      empName: "Jane Smith",
      inTime: "08:45 AM",
      outTime: "05:15 PM",
      status: "Present",
    },
    { empName: "Alice Johnson", inTime: null, outTime: null, status: "Absent" },
    {
      empName: "Mike Brown",
      inTime: "09:15 AM",
      outTime: "05:00 PM",
      status: "Present",
    },
  ];
  const handleDrawerToggle = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <div>
      <Navbar onMenuClick={toggleMenu} />
      <SideBar open={menuOpen} onClose={toggleMenu} />
      <main>{children}</main>
    </div>
  );
};

export default DashboardLayout;
